import React, {Component} from "react";
import {Image, Row, Col, Table, Card, Form, Button, Spinner, ButtonGroup, DropdownButton, Tab, Tabs, Dropdown, Navbar} from "react-bootstrap";
import {DatePicker, Switch, Progress} from "antd";
import {FaPencilAlt, FaPlus} from "react-icons/fa";

import Side from "./Sidebar";
import Top from "./Topbar";
import EditDoc from "./EditDoctor";
import "antd/dist/antd.css";
import moment from "moment";
import ProfileProgress from "./ProfileProgress";

import C from "../lib/Config";

const dateFormat = "DD/MM/yyyy";
export default class Doctor extends Component {
  constructor() {
    super();
    this.state = {
      context: this,
      userId: localStorage.getItem("userId"),
      firstName: "",
      lastName: "",
      username: "",
      dob: "",
      phoneNumber: "",
      genderId: "",
      genderName: "",
      userInfo: "",
      address: "",
      specialityName: "",
      phoneContryCode: "",
      countryCode: "",
      profDegreeId: "",
      profDegreeName: "",
      roleName: "",
      isShowNonEditableView: true,
      userInstituteXrefList: [],
      profilePictureData: localStorage.getItem("profilePictureData") ? localStorage.getItem("profilePictureData") : "",
      isShowEditableView: false,
      profileCompletionPercent: 100,
      password: "",
      errorMessage: "",
      successMessage: "",
      activeTabKey: "ProfessionalDegree",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleTabSelect = (key) => {
    this.setState({ activeTabKey: key });
  };

  
  toggleProfileView = () => {
    const {isShowNonEditableView, isShowEditableView} = this.state;
    this.setState({
      isShowNonEditableView: !isShowNonEditableView,
      isShowEditableView: !isShowEditableView,
    });
    this.getUserDetail();
  };

  componentDidMount() {
    this.getUserDetail();
  }

  profileUpdateSuccessHandler = (profilePic) => {
    this.toggleProfileView();
    this.getUserDetail();
    this.setState({ profilePictureData: profilePic })
    localStorage.setItem('profilePictureData', profilePic);
  };

  getUserDetail() {
    return fetch(C.getUrl() + '/user/getUserByUserId/' + this.state.userId)
      .then(res => res.json())
      .then(res => {
        let resObj = res;
        this.setState({profileCompletionPercent: 0});
        console.log("-- USER DATA [API RAW] : " + JSON.stringify(JSON.parse(resObj.message)));
        this.setUserDetail(JSON.parse(resObj.message));
        this.setProfileProgress(JSON.parse(resObj.message));
      })
      .catch(err => {
        console.log("Error : " + err);
      });
  }
  setUserDetail(user) {
    console.log("-- USER DATA : " + JSON.stringify(user));
    this.setState({firstName: user.firstName});
    this.setState({lastName: user.lastName});
    this.setState({username: user.username});
    this.setState({dob: user.dob});
    this.setState({phoneNumber: user.phoneNumber});
    this.setState({userInfo: user.userInfo});
    this.setState({genderId: user.genderDto.genderId});
    this.setState({genderName: user.genderDto.genderName});
    this.setState({address: user.address});
    this.setState({roleName: user.userRoleDto.roleName});

    this.setState({phoneContryCode: user.countryDTO.phoneContryCode});
    this.setState({countryCode: user.countryDTO.countryCode});

    this.setState({profDegreeId: user.profDegreeDto.profDegreeId});
    this.setState({profDegreeName: user.profDegreeDto.profDegreeName});

    if (user.userInstituteXrefDTOList != null && user.userInstituteXrefDTOList != "undefined") {
      let userInstituteXrefDTOList = user.userInstituteXrefDTOList;
      userInstituteXrefDTOList.map((item, index) => {
        item.activeInd = (item.activeInd === 'Y') ? true : false;
      });
      this.setProfileProgress(userInstituteXrefDTOList);
      this.setState({userInstituteXrefList: userInstituteXrefDTOList});
    }
    if (user.userSpecialityXrefDTOList != null && user.userSpecialityXrefDTOList != "undefined") {
      var selectedSpecilityName = [];
      user.userSpecialityXrefDTOList.map(function (d) {
        selectedSpecilityName.push(d.specialityMasterDTO.specialityName);
      });
      this.setProfileProgress(selectedSpecilityName);
      this.setState({specialityName: selectedSpecilityName});
    }
  }

  activeInactiveStatusHandler = (status, event, data, idx) => {
    const userConfirmed = window.confirm("Are you sure you want to update the institute status?");
    if (userConfirmed) {
    const {userInstituteXrefList} = this.state;
    console.log("--- STATUS : " + status);
    console.log("---- INSTITUE ID : " + data.instituteMstDTO.instituteId);
    console.log("---- INSTITUE NAME : " + data.instituteMstDTO.instituteName);

    let userInstituteXrefDTOList = userInstituteXrefList;
    userInstituteXrefDTOList.map((item, index) => {
      if (idx === index) {
        item.activeInd = status;
      }
    });
    console.log("--- UPDATED USER INISTITUE : " + JSON.stringify(userInstituteXrefDTOList));
    this.setState({userInstituteXrefList: userInstituteXrefDTOList});

    this.updateInstituteStatusApi(status, data);
    }else { 
      console.log("User canceled the status update.");
    }
  };

  updateInstituteStatusApi = async (switchStatus, data) => {

    let jsonData = new Object();
    jsonData["userInstXrefId"] = data.userInstXrefId;
    jsonData["instituteId"] = data.instituteMstDTO.instituteId;
    jsonData["instituteName"] = data.instituteMstDTO.instituteName;
    jsonData["activeInd"] = switchStatus ? 'Y' : 'N';

    let inputData = {
      instituteMstDTO: jsonData,
    };

    console.log('-- UPDATE INSTITUTE STATUS : ' + JSON.stringify(inputData.instituteMstDTO));

    return fetch(C.getUrl() + "/institute/updateUserInstituteActiveStatus", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(inputData.instituteMstDTO),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(res => {
        let obj = res;
        let error = obj.subErrors;
        if (error !== null && error !== "") {
          alert(error);
        } else {
          console.log("Institute status updated successfully.");
        }
      })
      .catch(err => {
        console.log("Error updating institute status : " + err);
      });
  }

  /**
   * Calculate percentage -
   * If the data is filled then add 10 percent to the current percent.
   * If the data is not filled then return current percent.
   * If the data is greater than 100 then return 100 percent.
   */
  calculatePercent = (currentPercent, obj) => {
    let percent = 0;
    console.log("---- DATA FILLED : " + this.isDataFilled(obj));
    if (this.isDataFilled(obj)) {
      percent = currentPercent + 10;
      if (percent > 100) {
        percent = 100;
      }
    } else {
      percent = currentPercent;
    }
    return percent;
  };

  //Check if the data is filled or not
  isDataFilled = obj => {
    if (obj !== "") {
      return true;
    }

    if (obj instanceof Array && obj !== null) {
      if (obj.length !== 0) {
        return true;
      }
    }

    return false;
  };

  setProfileProgress = data => {
    const {profilePictureData, profileCompletionPercent} = this.state;

    let totalPercent = profileCompletionPercent;
    //totalPercent = this.calculatePercent(totalPercent, data.profDegreeDto.profDegreeName);
    if (data instanceof Array) {
      console.log("-- ARRAY INSTANCE");
      totalPercent = this.calculatePercent(totalPercent, data); // Two Array instance - 10 + 10 = 20
    } else {
      totalPercent = this.calculatePercent(totalPercent, data.firstName); // 0 + 10
      totalPercent = this.calculatePercent(totalPercent, data.lastName); // [Blank for example] - value returned will be 10
      totalPercent = this.calculatePercent(totalPercent, data.phoneNumber); // 10 + 10 = 20
      totalPercent = this.calculatePercent(totalPercent, data.dob); // 20 + 10 = 30
      totalPercent = this.calculatePercent(totalPercent, data.userInfo); // 30 + 10 = 40
      totalPercent = this.calculatePercent(totalPercent, profilePictureData); //40 + 10 = 50
      totalPercent = this.calculatePercent(totalPercent, data.address); // 50 +10 = 60
      totalPercent = this.calculatePercent(totalPercent, data.username); // 60 + 10 = 70
    }

    console.log("--- PERCENTAGE : " + totalPercent);

    this.setState({profileCompletionPercent: totalPercent});
  };
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
  
    const { username, password, dob } = this.state;
    // Convert dob from display format to YYYY-MM-DD if needed
    let dobForSubmit = dob;
    if (dob && !dob.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Try to parse various date formats
      const parsedDate = moment(dob, ['MM/DD/YYYY', 'MMM DD, YYYY', 'DD MMM YYYY', 'YYYY-MM-DD']);
      if (parsedDate.isValid()) {
        dobForSubmit = parsedDate.format('YYYY-MM-DD');
      }
    }
    fetch(C.getUrl() + "/user/resetpwd", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password, dob: dobForSubmit }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok " + res.statusText);
        }
        return res.json();
      })
      .then((res) => {
        if (res.statusCode === 200) {
          this.setState({
            successMessage: "Password updated successfully!",
            errorMessage: "",
          });
          this.resetFormField();
        } else {
          this.setState({
            errorMessage: res.message || "Failed to update password.",
            successMessage: "",
          });
        }
      })
      .catch((err) => {
        console.error("Error during password update:", err);
        this.setState({
          errorMessage:
            "There was an error connecting to the server. Please try again later.",
          successMessage: "",
        });
      });
  }

  resetFormField() {
    this.setState({
      username: "",
      password: "",
      dob: "",
    });
  }

  render() {
    const {context, isShowEditableView, isShowNonEditableView, profileCompletionPercent,
      username,
      password,
      dob,
      errorMessage,
      successMessage,
    } = this.state;
    const countryCodePhoneNum = this.state.countryCode + " " + this.state.phoneContryCode;
    return (
      <div className="d-flex" id="wrapper">
        {<Side />}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            {<Top profilePic={this.state.profilePictureData}/>}
            <div className="container-fluid">
              <div className="app-content">
                {isShowNonEditableView && (
                  <section className="section" id="accordion">
                    <Row>
                      <Col lg="3" md="12">
                        <div>{profileCompletionPercent !== 100 ? <ProfileProgress percentProgress={profileCompletionPercent} /> : null}</div>
                        <div className="card text-center border-0 pb-0">
                          <div className="bg-light"></div>
                          <div className="card-body">
                            {(() => {
                                if (this.state.profilePictureData !== "undefined" && this.state.profilePictureData !== null && this.state.profilePictureData !== "") {
                                    return (
                                        <Image src={this.state.profilePictureData} className="rounded-circle profile mb-3" />
                                    )
                                }else{
                                    return (
                                        <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle profile mb-3" />
                                    )
                                }
                            })()}
                            <div>
                              <h1 className="card-title">
                                <b>
                                  {this.state.firstName} {this.state.lastName}
                                </b>
                              </h1>
                              <p className="card-description font-weight-bold">{this.state.profDegreeName}</p>
                              <p className="card-description ">{this.state.userInfo}</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg="9" md="12">
                        <div className="card border-0 pb-0">
                          <div className="card-body flex-wrap border-0 pb-0">
                            {(() => {
                              if (this.state.roleName == "Doctor") {
                                return (
                                  <div className="pull-right mt-2">
                                    <Button variant="secondary" className="float-right btn-primary" onClick={this.toggleProfileView}>
                                      <FaPencilAlt className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                                      Edit
                                    </Button>
                                  </div>
                                );
                              }
                            })()}
                            <Tabs activeKey={this.state.activeTabKey} onSelect={this.handleTabSelect} id="uncontrolled-tab-example">
                              <Tab eventKey="generalInfo" title="General Info">
                                <Row className="mt-4 mb-4">
                                  <Col lg="4">
                                    <Form.Group>
                                      <Form.Label>First Name</Form.Label>
                                      <Form.Control type="text" value={this.state.firstName} name="firstName" disabled />
                                    </Form.Group>
                                    <Form.Group>
                                      <Form.Label>Email ID</Form.Label>
                                      <Form.Control type="email" value={this.state.username} name="email" disabled />
                                    </Form.Group>
                                    <Form.Group>
                                      <Form.Label>Date of Birth</Form.Label>
                                      <Form.Control type="text" id="" value={this.state.dob ? moment(this.state.dob, ['MM/DD/YYYY', 'MMM DD, YYYY', 'DD MMM YYYY', 'YYYY-MM-DD']).format(dateFormat) : ''} name="dob" disabled />
                                    </Form.Group>
                                    {/* <Form.Group className="input-group pt-3">
                                      <Form.Control type="text" id="" name="country" value={countryCodePhoneNum} style={{maxWidth: "100px"}} disabled></Form.Control>
                                      <Form.Control type="text" maxLength="10" id="" placeholder="Contact No" value={this.state.phoneNumber} className="ml-2" name="phoneNumber1" disabled />
                                    </Form.Group> */}
                                  <Form.Group className="pt-3">
                                  <div className="row">
                                    <div className="col-md-5">
                                      <Form.Label>Country Code</Form.Label>
                                      <Form.Control 
                                        type="text" 
                                        id="" 
                                        name="country" 
                                        value={countryCodePhoneNum} 
                                        style={{ maxWidth: "100px" }} 
                                        disabled 
                                      />
                                    </div>
                                    <div className="col-md-7">
                                      <Form.Label>Contact No</Form.Label>
                                      <Form.Control 
                                        type="text" 
                                        maxLength="10" 
                                        id="" 
                                        placeholder="Contact No" 
                                        value={this.state.phoneNumber} 
                                        name="phoneNumber1" 
                                        disabled 
                                      />
                                    </div>
                                  </div>
                                </Form.Group>
                                  </Col>
                                  <Col lg="4">
                                    <Form.Group>
                                      <Form.Label>Last Name</Form.Label>
                                      <Form.Control type="text" value={this.state.lastName} name="lastName" disabled />
                                    </Form.Group>
                                    <Form.Group>
                                      <Form.Label>Speciality</Form.Label>
                                      <Form.Control type="text" value={this.state.specialityName} name="specialityName" disabled />
                                    </Form.Group>
                                    <Form.Group>
                                      <Form.Label>Gender</Form.Label>
                                      <Form.Control type="text" value={this.state.genderName} name="gender" disabled />
                                    </Form.Group>
                                  </Col>
                                  <Col lg="4">
                                    <Form.Group>
                                      <Form.Label>Address</Form.Label>
                                      <Form.Control as="textarea" defaultValue={this.state.address} rows={4} disabled />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Tab>
                              <Tab eventKey="ProfessionalDegree" title="Associated Institute">
                                <Row className="mt-4">
                                  <Col lg="12">
                                    <div className="single-item">
                                      <table id="example" className="table table-striped table-hover text-nowrap dataTable no-footer" role="grid" aria-describedby="example_info">
                                        <thead className="thead-light">
                                          <tr role="row">
                                            <th className="sorting" aria-controls="example" colspan="1">
                                              #
                                            </th>
                                            <th className="sorting_asc" aria-controls="example" colspan="1" aria-sort="ascending">
                                              Associated Institute
                                            </th>
                                            <th className="sorting" aria-controls="example" colspan="1">
                                              City
                                            </th>
                                            <th className="sorting" aria-controls="example" colspan="1">
                                              State
                                            </th>
                                            <th className="sorting" aria-controls="example" colspan="1">
                                              Country
                                            </th>
                                            <th className="sorting" aria-controls="example" colspan="1">
                                              Emergency Contact No.
                                            </th>
                                            <th className="sorting" aria-controls="example" colspan="1">
                                              Active/ Inactive
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.userInstituteXrefList != "undefined" &&
                                            this.state.userInstituteXrefList.map(function (d, idx) {
                                              return (
                                                <tr key={idx} role="row" className="odd">
                                                  <td>{idx + 1}</td>
                                                  <td>{d.instituteMstDTO.instituteName}</td>
                                                  <td>{d.instituteMstDTO.cityMstDTO.cityCode}</td>
                                                  <td>{d.instituteMstDTO.stateMstDTO.stateName}</td>
                                                  <td>{d.instituteMstDTO.countryDTO.countryName}</td>
                                                  <td>{d.instituteMstDTO.emergencyContactNo}</td>
                                                  <td>
                                                    <Switch
                                                      className="custom-switch-checked"
                                                      checked={d.activeInd}
                                                      onChange={(status, event) => {
                                                        context.activeInactiveStatusHandler(status, event, d, idx);
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </Col>
                                </Row>
                              </Tab>
                            </Tabs>
                            <div className="mt-4">
                              <h3>Reset Password</h3>
                              {errorMessage && (
                                <div style={{ color: "red" }}>{errorMessage}</div>
                              )}
                              {successMessage && (
                                <div style={{ color: "green" }}>{successMessage}</div>
                              )}
                              <Form onSubmit={this.handleSubmit}>
                                <Row>
                                  <Col lg="4">
                                    <Form.Group>
                                      <Form.Label>Email Address:</Form.Label>
                                      <Form.Control
                                        type="email"
                                        name="username"
                                        value={username}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </Form.Group>
                                    <Form.Group>
                                      <Form.Label>New Password:</Form.Label>
                                      <Form.Control
                                        type="password"
                                        name="password"
                                        value={password}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </Form.Group>
                                    <Form.Group>
                                      <Form.Label>Date of Birth:</Form.Label>
                                      <Form.Control
                                        type="date"
                                        name="dob"
                                        value={dob && !dob.match(/^\d{4}-\d{2}-\d{2}$/) ? moment(dob, ['MM/DD/YYYY', 'MMM DD, YYYY', 'DD MMM YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : dob}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </Form.Group>
                                    <Button
                                      variant="secondary" type="submit"
                                      className="float-right btn-primary"
                                      
                                    >
                                      Reset Password
                                    </Button>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </section>
                )}
                {isShowEditableView && <EditDoc cancelEdit={() => this.toggleProfileView()} profileUpdateSuccess={(val) => this.profileUpdateSuccessHandler(val)} activeTabKey={this.state.activeTabKey}/>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
